import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageType } from './analytics/newrelic/enums/PageType';
import { CustomPreloadingStrategyService } from './custom-preloading-strategy.service';
import { DetailsPageResolver } from './shared/resolvers/details-page.resolver';
import { PlayerResolver } from './shared/resolvers/player.resolver';
import { SessionService } from './shared/services/session/session.service';

const routes: Routes = [
  {
    path: 'on-boarding',
    data: { pageID: PageType.Language },
    loadChildren: () => import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
  },
  {
    path: 'on-boarding',
    data: { pageID: PageType.Language },
    loadChildren: () => import('./onboarding/onboarding.module').then((m) => m.OnboardingModule),
  },
  {
    path: 'player/:type/:id',
    loadChildren: () => import('./player/player.module').then((m) => m.PlayerModule),
    data: { preload: true, pageID: PageType.Player },
    resolve: {
      playerData: PlayerResolver,
    },
  },
  {
    path: 'player/:type/:id/:title/:seasonNumber/:episodeNumber/:providerName/:releaseYear/:seasonId/:seriesId',
    loadChildren: () => import('./player/player.module').then((m) => m.PlayerModule),
    data: { pageID: PageType.Player },
    resolve: {
      playerData: PlayerResolver,
    },
  },
  {
    path: 'player/:type/:id/:title/:seasonNumber/:episodeNumber/:selectedTabId/:providerName/:releaseYear/:seasonId/:seriesId',
    loadChildren: () => import('./player/player.module').then((m) => m.PlayerModule),
    data: { pageID: PageType.Player },
    resolve: {
      playerData: PlayerResolver,
    },
  },
  {
    path: '',
    data: { preload: true, pageID: PageType.Browse, isApp: true },
    loadChildren: () => import('./storefront/storefront.module').then((m) => m.StorefrontModule),
  },
  {
    path: ':contentType/:id',
    data: { pageID: PageType.Details },
    loadChildren: () => import('./details-page/details-page.module').then((m) => m.DetailsPageModule),
    resolve: {
      detailsData: DetailsPageResolver,
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: CustomPreloadingStrategyService,
    }),
  ],
  providers: [CustomPreloadingStrategyService, SessionService, DetailsPageResolver, PlayerResolver],
  exports: [RouterModule],
})
export class AppRoutingModule {}
